"use client";
import { j as e } from "./index.es73.js";
import { forwardRef as m, useMemo as c } from "react";
import { makeUniqueId as h } from "./index.es139.js";
m(
  ({
    label: i,
    isChecked: r,
    onChange: o,
    isDefaultChecked: s,
    isDisabled: l,
    inputId: a,
    ...t
  }, n) => {
    const d = c(() => h(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-radio-button", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...t,
          ref: n,
          type: "radio",
          id: a || d,
          onChange: o,
          defaultChecked: s,
          disabled: l,
          checked: r
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: a || d, children: i })
    ] });
  }
);
//# sourceMappingURL=index.es75.js.map
